export default __webpack_public_path__ + "static/media/check.97013eac.svg";